module.exports = __webpack_public_path__ + "img/renxinghua@2x.c7b1b98c.png";